import moment from 'moment'

export default function toDayAndHour(date) {
  if (!date) return ''
  return moment(date).format('DD/MM - hh:mm')
}
